import { CHAT_CONFIGURATION } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { getWebChatwidgetDetails } from "../../api/chat_call_Sessions";
import * as helper from "../../helpers/webchat";
import { withItem } from "react-bootstrap-typeahead";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

const initialState = {
  title: loginUserCcaasDetail?.companyName !== null ? loginUserCcaasDetail?.companyName : "" + " Bot",
  aliasTitle: '',
  greeting: "",
  description: "One bot to help them all",
  chatFlowId: "",
  callFlowName: "",
  chatIconLogo: "",
  domainArr: [] as any,
  font: "",
  domainName: "",
  position: "flex-end",
  roundedCorners: 25,
  chatIconShape: "24",
  chatHeaderColor: "#5B55FF",
  widgetIconBg: "#5B55FF",
  primaryButtonBg: "#000",
  agentMessageColor: "#E3E4E5",
  customerMessageColor: "#E2E2FA",
  actionMessageColor: "#575CFF",
  uploadDocs: false,
  createContact: false,
  chatToVoice: false,
  chatToEmail: false,
  conversationHistory: false,
  isDisplaySupportNumber: false,
  supportNumber: "",
  isWidgetUnbranding: true,
  isCallUsIcon: false,
  chatRecommentCount: 1,
  isSendCallBackReq: false,
  primaryForm: [],
  consentForm: [],
  isSave: false,
  prechatForm: false,
  codeSnippet: "",
  hasFormError: false,
  apiData: [] as any,
  searchData: [] as any,
  errorMsg: "",
  loading: false,
  searchName: "",
  dynamicChatIcon: "",
  attachIcon: false,
  dynamictextHeader: "white",
  dynamicChatIconColor: "white",
  dynamicAgentMessageTextColor: "black",
  dynamicButtonText: "white",
  dynamicCustomerMessageTextColor: "black",
  primaryTitleCustomize: "Hello! Let's get started",
  primaryMessageCustomize: "To start a conversation, please provide your details",
  primaryButtonLabelCustomize: "Start Conversation",
  primaryButtonBlock: true,
  primaryButtonInline: false,
  primaryInlineCenter: false,
  primaryInlineLeft: false,
  primaryInlineRight: false,
  ButtonSizeType: 1,
  ButtonPositionType: 1,
  botIconLogo: "",
  widgetIconLogo: "",
  launcherText: "",
  backgroundImage: "none",
  chatFlowTemplate: [],
  welcomeMsg: "Welcome, We’re " + loginUserCcaasDetail?.companyName,
  nextTabKey: 1,
  previewChatHistory: [],
  previewChatKeywords: [],
  isPreviewChat: false,
  websiteId: '',
  knowledgeBase: {},
  dynamiclanguage: 'en',
  triggerMessage: "",
  triggerStatus: false,
  threshold: {
    isCallBack: 0,
    thresholdvalue: 24
  },
  autoResChatSettings: {
    handoffMessage: 'Please wait while I connect you to an available agent.',
    busyMessage: 'All our agents are currently busy but we will connect you asap. You can wait or please leave your name, email, and phone number, and we will get back to you.',
    isBusyCallbck: false,
    busyCallbckMsg: 'please leave us your name & email',
    unavilableMessage: 'All our agents are currently unavailable. Please leave your name, email, and phone number, and we will get back to you.',
    isUnavailableCallbck: false,
    UnavailableCallbckMsg: 'please leave us your name & email',
    businessMessage: 'Our agents are only available between <start time> and <end time>. Please leave your name, phone number and email ID and we will get back to you!',
    isBusinessCallbck: false,
    businessCallbckMsg: 'please leave us your name & email',
    chatInactivity: 5,
    chatInactivityMsg: 'Are we still Connected!!',
    chatOtherInactivity: 0,
    chatOtherInactivityMsg: 'Are we still Connected!!',
    chatTimeout: 2,
    chatTimeoutMsg: "We seem to have lost you so we’re ending this chat session. Thanks for contacting us and please feel free to get back in touch for any further assistance.",
    isenableTracker: true,
    trackerType: '',
    trackerName: '',
    trackerDelay: 1,
    trackerMsg: '',
    addonMultiLanguageData: [],
    addonMultiLangFullList: []
  },
  isChatflow: false,
  leadGeneration: {},
  chatOnboardKey: 1,
  webchatid: "",
  webSourceId: "",
  getIndustry: [],
  widgetLanger: false,
  brandColor: 1,
  emailLink: false,
  downloadStatus: false,
  chatPreview: false,
  isFinish: false,
  currentTab: 1,
  triggerShown: false,
  buildertour: 0,
  isSkipTour: false,
  notificationSound: "Ethereal",
  notificationSoundUrl: "https://ccaas-storage.worktual.co.uk/chat/10592/Ethereal.mp3",
  isConsentForm: false,
  lastEnabledToggle:[] as any,
  consentFormLang: 2,
  consentMessage: `Hi there! We at [Company Name] would love to talk with you. Under the EU General Data Protection Regulation (GDPR), we need your approval for our use of personal information (e.g., your name and email address) that you may provide as we communicate:
(1) We'll store your personal information so that we can pick up the conversation if we talk later.
(2) We may send you emails to follow up on our discussion here.
(3) We may send you emails about upcoming services and promotions.
Is this okay with you?`,
  privacyPolicyLink: "",
  privacyPolicyLinkText: "View our Privacy Policy",
  optInButton: "Yes, I agree",
  optOutButton: "No, not now",
  optOutConfirmation: "That's okay. You can view the policy at any time and consent to continue.",
  optOutConfirmationBox: false,

  // primaryButtonbg:"#000"
};

const chatConfigurationSlice: any = createSlice({
  name: CHAT_CONFIGURATION,
  initialState,
  reducers: {
    attachIcon: (state, { payload }) => {
      state.attachIcon = payload;
    }, primaryButtonBg: (state, { payload }) => {
      state.primaryButtonBg = payload;
    },
    webSourceId: (state, { payload }) => {
      state.webSourceId = payload;
    },
    webchatid: (state, { payload }) => {
      state.webchatid = payload;
    },
    chatOnboardKey: (state, { payload }) => {
      state.chatOnboardKey = payload;
    },
    ButtonSizeType: (state, { payload }) => {
      state.ButtonSizeType = payload;
    },
    isChatflow: (state, { payload }) => {
      state.isChatflow = payload;
    },
    knowledgeBaseSet: (state, { payload }) => {
      let dataArr: any = [];
      let value = payload.map((data: any) => {
        dataArr.push({
          skid: data.key,
          value: data.value,
        });
      });

      state.knowledgeBase = dataArr;

    },
    getWebsiteId: (state, { payload }) => {
      state.websiteId = payload;
    },
    isPreviewChat: (state, { payload }) => {
      state.isPreviewChat = payload;
    },
    ButtonPositionType: (state, { payload }) => {
      state.ButtonPositionType = payload;
    },
    dynamicButtonText: (state, { payload }) => {
      state.dynamicButtonText = payload;
    },
    primaryButtonBlock: (state, { payload }) => {
      state.primaryButtonBlock = payload;
    },
    primaryButtonInline: (state, { payload }) => {
      state.primaryButtonInline = payload;
    },
    primaryInlineCenter: (state, { payload }) => {
      state.primaryInlineCenter = payload;
    },
    primaryInlineLeft: (state, { payload }) => {
      state.primaryInlineLeft = payload;
    },
    previewChatHistory: (state, { payload }) => {
      state.previewChatHistory = payload;

    },

    previewChatKeywords: (state, { payload }) => {
      state.previewChatKeywords = payload;
    },
    primaryInlineRight: (state, { payload }) => {
      state.primaryInlineRight = payload;
    },
    basicChatSettings: (state, { payload }) => {
      state.title = payload.title;
      state.aliasTitle = payload.aliasTitle;
      state.greeting = payload.greeting;
      state.description = payload.description;
      state.chatFlowId = payload.chatFlowId;
      state.callFlowName = payload.callFlowName;
      state.chatIconLogo = payload.chatIconLogo;
      state.triggerMessage = payload.triggerMessage;
      state.triggerStatus = payload.triggerStatus;

    },
    threshold: (state, { payload }) => {
      if (payload.isCallBack) {
        state.threshold.isCallBack = payload.isCallBack;
      } else if (payload.thresholdvalue) {
        state.threshold.thresholdvalue = payload.thresholdvalue;
      }
    },
    // automatedResponseMsgSettings: (state, { payload }) => {
    //   state.handoffMessage = payload.handoffMessage;
    //   state.busyMessage = payload.busyMessage;
    //   state.isBusyCallbck = payload.isBusyCallbck;
    //   state.unavilableMessage = payload.unavilableMessage;
    //   state.isUnavailableCallbck = payload.isUnavailableCallbck;
    //   state.busyCallbckMsg = payload.busyCallbckMsg;
    //   state.UnavailableCallbckMsg = payload.UnavailableCallbckMsg;
    //   state.businessMessage = payload.businessMessage;
    //   state.isBusinessCallbck = payload.isBusinessCallbck;
    //   state.chatInactivity = payload.chatInactivity;
    //   state.chatInactivityMsg = payload.chatInactivityMsg;
    //   state.chatTimeout = payload.chatTimeout;
    //   state.chatTimeoutMsg = payload.chatTimeoutMsg;

    // },
    autoResChatSettings: (state, { payload }) => {
      state.autoResChatSettings = payload.autoResChatSettings;
    },
    botChatSettings: (state, { payload }) => {
      state.botIconLogo = payload.botIconLogo;
    },
    chatFlowSettings: (state, { payload }) => {
      state.chatFlowTemplate = payload.chatFlowTemplate;
    },
    widgetChatText: (state, { payload }) => {
      state.launcherText = payload.launcherText;
    },
    backgroundSettings: (state, { payload }) => {
      state.backgroundImage = payload.backgroundImage;
    },
    widgetChatSettings: (state, { payload }) => {
      state.widgetIconLogo = payload.widgetIconLogo;
    },
    templateWelcomeMessage: (state, { payload }) => {
      state.welcomeMsg = payload.welcomeMsg;
    },
    primaryTitleCustomize: (state, { payload }) => {
      state.primaryTitleCustomize = payload;
    },
    primaryMessageCustomize: (state, { payload }) => {
      state.primaryMessageCustomize = payload;
    },
    primaryButtonLabelCustomize: (state, { payload }) => {
      state.primaryButtonLabelCustomize = payload;
    },
    nextTabKey: (state, { payload }) => {
      state.nextTabKey = payload;
    },
    personalisation: (state, { payload }) => {
      state.font = payload.font;
      state.position = payload.position;
      state.roundedCorners = payload.roundedCorners;
      state.chatIconShape = payload.chatIconShape;
      state.chatHeaderColor = payload.chatHeaderColor;
      state.dynamictextHeader = payload.dynamictextHeader;
      state.dynamicAgentMessageTextColor = payload.dynamicAgentMessageTextColor;
      // state.dynamicButtonText = payload.dynamicButtonText;    
      state.dynamicCustomerMessageTextColor = payload.dynamicCustomerMessageTextColor;
      state.dynamicChatIconColor = payload.dynamicChatIconColor;
      state.widgetIconBg = payload.widgetIconBg;
      // state.primaryButtonBg = payload.primaryButtonBg; 
      state.agentMessageColor = payload.agentMessageColor;
      state.customerMessageColor = payload.customerMessageColor;
      state.actionMessageColor = payload.actionMessageColor;
      state.uploadDocs = payload.uploadDocs;
      state.createContact = payload.createContact;
      state.chatToVoice = payload.chatToVoice;
      state.chatToEmail = payload.chatToEmail;
      state.downloadStatus = payload?.downloadStatus;
      state.conversationHistory = payload.conversationHistory;
      state.isDisplaySupportNumber = payload.isDisplaySupportNumber;
      state.supportNumber = payload.supportNumber;
      state.isWidgetUnbranding = payload.isWidgetUnbranding;
      state.isCallUsIcon = payload.isCallUsIcon;
      state.chatRecommentCount = payload?.chatRecommentCount;
      state.isSendCallBackReq = payload.isSendCallBackReq;
      state.notificationSound = payload.notificationSound;
      state.notificationSoundUrl = payload.notificationSoundUrl;
    },
    dynamicChatIcon: (state, { payload }) => {
      state.dynamicChatIcon = payload;
    },
    dynamiclanguage: (state, { payload }) => {
      state.dynamiclanguage = payload;
    },
    primaryForm: (state, { payload }) => {
      state.primaryForm = payload.primaryForm;
      state.prechatForm = payload.prechatForm;
    },
    isSave: (state, { payload }) => {
      state.isSave = payload.isSave;
    },
    codeSnippet: (state, { payload }) => {
      state.codeSnippet = payload.codeSnippet;
    },
    formError: (state, { payload }) => {
      state.hasFormError = payload.hasFormError;
    },
    setApiData: (state, { payload }) => {
      state.apiData = payload;
      state.searchData = payload;
    },
    loading: (state, { payload }) => {
      state.loading = payload;
    },
    domainName: (state, { payload }) => {
      state.domainName = payload;
    },
    doSearch: (state, { payload }) => {
      state.searchName = payload;
      helper.filterSearchWeb(state);
    },
    statusApiData: (state, { payload }) => {
      state.apiData = payload;
      state.searchData = payload;
    },
    leadGeneration: (state, { payload }) => {
      state.leadGeneration = payload;
    },
    getIndustry: (state, { payload }) => {
      state.getIndustry = payload;
    },
    widgetTextLauncher: (state, { payload }) => {
      state.widgetLanger = payload.widgetLanger;
    },
    brandColor: (state, { payload }) => {
      state.brandColor = payload.brandColor;
    },
    emailLink: (state, { payload }) => {
      state.emailLink = payload;
    },
    setDownloadStatus: (state, { payload }) => {
      state.downloadStatus = payload
    },
    chatPreview: (state, { payload }) => {
      state.chatPreview = payload;
    },
    isFinish: (state, { payload }) => {
      state.isFinish = payload;
    },
    currentTab: (state, { payload }) => {
      state.currentTab = payload;
    },
    triggerShown: (state, { payload }) => {
      state.triggerShown = payload;
    },
    builderTour: (state, { payload }) => {
      if (payload.value !== undefined) {
        state.buildertour = payload.value;
      }
      if (payload.skipTour !== undefined) {
        state.isSkipTour = payload.skipTour
      }
    },
    consentForm: (state, { payload }) => {
      state.consentForm = payload.consentForm;
      // state.isConsentForm = payload.isConsentForm;
    },

    isConsentForm: (state, { payload }) => {
      state.isConsentForm = payload;
    },
    lastEnabledToggle: (state, { payload }) => {
      if(state.lastEnabledToggle.includes(payload)){
        state.lastEnabledToggle = state.lastEnabledToggle.filter((item : any) => item !== payload);
      }else{
        state.lastEnabledToggle.push(payload)
      }
    },
    consentFormLang: (state, { payload }) => {
      state.consentFormLang = payload;
    },
    consentMessage: (state, { payload }) => {
      state.consentMessage = payload;
    },
    privacyPolicyLink: (state, { payload }) => {
      state.privacyPolicyLink = payload;
    },
    privacyPolicyLinkText: (state, { payload }) => {
      state.privacyPolicyLinkText = payload;
    },
    optInButton: (state, { payload }) => {
      state.optInButton = payload;
    },
    optOutButton: (state, { payload }) => {
      state.optOutButton = payload;
    },
    optOutConfirmation: (state, { payload }) => {
      state.optOutConfirmation = payload;
    },
    optOutConfirmationBox: (state, { payload }) => {
      state.optOutConfirmationBox = payload;
    },

    reset: () => { },
  },
  extraReducers: (builder) => {
    builder.addCase(getWebChatwidgetDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWebChatwidgetDetails.fulfilled, (state, { payload }) => {
      state.apiData = payload.data?.getPrimaryField;
      state.searchData = payload.data?.getPrimaryField;
      state.loading = false;
    });
    builder.addCase(getWebChatwidgetDetails.rejected, (state) => {
      state.errorMsg = "Failed To Get Data";
    });
  },
});

export const ChatConfigurtationActions = chatConfigurationSlice.actions;
export default chatConfigurationSlice.reducer;
